/* ------------------------------------------ GRYFF RESPONSIVE CONTROLLER - CHRIS 20.07.2016 ----------------------------------------- */
import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import { renderTabSettings } from '../sidebar/global-style/renderTabSetting';
import emitter from "@/emitter";

(function (jQuery) {
  jQuery.gfResTool = function (element, options) {
    const defaults = {};
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;
    let _firstSwitchScreen = true;
    let _isResToolOpened = false;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gfFrameWrap = jQuery('#gfFrameWrap');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $gfFrameLoader = jQuery('#gfFrameLoader');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      const scrWidth = $gfFrame.contents().width();

      _this.setCurrentStatus(scrWidth);
      _this.resizeScreen('lg');

      $element
        .find('.current-screen')
        .off('click')
        .on('click', function () {
          $element.find('.select-screen').toggleClass('show');
          _isResToolOpened = $element.find('.select-screen').hasClass('show');

          return false;
        });

      jQuery('body')
        .off('mousedown.res')
        .on('mousedown.res', function (e) {
          if (_isResToolOpened) {
            const $target = jQuery(e.target);
            setTimeout(function () {
              if ($target.closest('#gfResTool').length == 0) {
                $element.find('.select-screen').removeClass('show');
                _isResToolOpened = false;
              }
            }, 0);
          }
        });
      $gryffBody.off('mousedown.res').on('mousedown.res', function (e) {
        if (_isResToolOpened) {
          const $target = jQuery(e.target);
          setTimeout(function () {
            if ($target.closest('#gfResTool').length == 0) {
              $element.find('.select-screen').removeClass('show');
              _isResToolOpened = false;
            }
          }, 0);
        }
      });

      const $a = $element.find('.select-screen a');
      let screenSizeTimeout;
      $a.off('click').on('click', function () {
        // close model select screen
        $element.find('.select-screen').removeClass('show');
        $element.find('.select-screen a').removeClass('active');
        jQuery(this).addClass('active');
        _isResToolOpened = false;

        const type = jQuery(this).attr('data-size');
        const text = jQuery(this).text();
        const svg = jQuery(this).find('.svg-icon').html();

        $element.find('.current-screen .selected-text').text(text);
        $element.find('.current-screen .selected-svg').html(svg);

        clearTimeout(screenSizeTimeout);
        screenSizeTimeout = setTimeout(function () {
          _this.resizeScreen(type);
        }, 10);
        return false;
      });

      let windowResizeTimeout;
      jQuery(window).resize(function () {
        clearTimeout(windowResizeTimeout);
        windowResizeTimeout = setTimeout(function () {
          const type = _this.getCurrentStatus();
          _this.resizeScreen(type);
        }, 10);
      });
    };

    this.setCurrentStatus = function (size) {
      let scrSize;
      if (isNaN(size)) {
        scrSize = size;
      } else if (size < 768) {
        scrSize = 'xs';
      } else if (size >= 768 && size < 992) {
        scrSize = 'sm';
      } else if (size >= 992 && size < 1200) {
        scrSize = 'md';
      } else {
        scrSize = 'lg';
      }

      $element.find('.current-screen').attr('data-size', scrSize);
    };

    this.getCurrentStatus = function () {
      return $element.find('.current-screen').attr('data-size');
    };

    this.resizeScreen = function (size) {
      emitter.emit("editor:resize-screen", size)
      const curentSize = _this.getCurrentStatus();
      if (curentSize == size) {
        return;
      }

      // Kiểm tra xem người dùng đang scrooll đến đâu
      const $mdSettings = $gfLeftSideBar.find('#md-settings');
      const $listBlock = $gryffEditor.children();
      let $firstBlockViewPort;
      let percentScreen;

      if (!_firstSwitchScreen) {
        if ($mdSettings.hasClass('active')) {
          var merId = $mdSettings.data('edittingID');
          var $merActive = $gryffBody.find('#' + merId);
          if ($merActive.length > 0) {
            var scrollTop = $($merActive).offset().top;
            const viewPortTop = $gfFrame.contents().find('html').scrollTop();
            const bodyHeight = window.innerHeight - 50;
            if (scrollTop > viewPortTop) {
              percentScreen = (scrollTop - viewPortTop) / bodyHeight;
            }
          }
        } else {
          var scrollTop = $gfFrame.contents().find('html').scrollTop();
          for (let i = 0; i < $listBlock.length; i++) {
            const $block = $($listBlock[i]);
            var top = $block.offset().top;
            if (top >= scrollTop) {
              $firstBlockViewPort = $block;
              break;
            }
          }
        }
      } else {
        _firstSwitchScreen = false;
      }

      let newWidth,
        scrWidth = $gfFrameWrap.width();

      let scrSize = 'lg';
      if (scrWidth < 768) {
        scrSize = 'xs';
      } else if (scrWidth >= 768 && scrWidth < 992) {
        scrSize = 'sm';
      } else if (scrWidth >= 992 && scrWidth < 1200) {
        scrSize = 'md';
      }

      if (!size || scrSize === size) {
        newWidth = '100%';
        window._zoomOut = 1;
        size = scrSize;
      } else {
        switch (size) {
          case 'xs':
            newWidth = 480;
            break;
          case 'sm':
            newWidth = 780;
            break;
          case 'md':
            newWidth = 1005;
            break;
          case 'lg':
            newWidth = 1210;
            break;
          default:
            if (parseFloat(size) > 0) {
              newWidth = parseFloat(size);
            }
            break;
        }

        if (newWidth > scrWidth) {
          window._zoomOut = scrWidth / newWidth;
        } else {
          window._zoomOut = 1;
        }
      }

      const style = {
        width: newWidth,
      };
      let translateX = 0,
        translateY = 0;

      if (window._zoomOut < 1) {
        const height = $gfFrameWrap.height() / window._zoomOut;
        style['height'] = height + 'px';

        translateX = (scrWidth - newWidth) / 2 / window._zoomOut;
        translateY = ($gfFrameWrap.height() - height) / 2 / window._zoomOut;

        style['transform'] = 'scale(' + window._zoomOut + ') translate(' + translateX + 'px, ' + translateY + 'px)';
        style['-webkit-transform'] =
          'scale(' + window._zoomOut + ') translate(' + translateX + 'px, ' + translateY + 'px)';
        style['-moz-transform'] =
          'scale(' + window._zoomOut + ') translate(' + translateX + 'px, ' + translateY + 'px)';
        style['-o-transform'] = 'scale(' + window._zoomOut + ') translate(' + translateX + 'px, ' + translateY + 'px)';
        style['-ms-transform'] = 'scale(' + window._zoomOut + ') translate(' + translateX + 'px, ' + translateY + 'px)';
      } else {
        style['height'] = '100%';
        style['transform'] = 'scale(' + window._zoomOut + ') translate(0px, 0px)';
        style['-webkit-transform'] = 'scale(' + window._zoomOut + ') translate(0px, 0px)';
        style['-moz-transform'] = 'scale(' + window._zoomOut + ') translate(0px, 0px)';
        style['-o-transform'] = 'scale(' + window._zoomOut + ') translate(0px, 0px)';
        style['-mstransform'] = 'scale(' + window._zoomOut + ') translate(0px, 0px)';
      }

      if (newWidth && window._zoomOut) {
        $gfFrame
          .css(style)
          .attr('data-width', style['width'])
          .attr('data-height', style['height'])
          .attr('data-zoomOut', window._zoomOut)
          .attr('data-tranX', translateX)
          .attr('data-tranY', translateY)
          .trigger('resizeFrame', [size]);
        _this.setCurrentStatus(size);
      }

      // !IMPROTANT set isCSSOverWrite
      window._isCSSOverWrite = [];
      window._isCSSOverWrite.length = 0;

      if ($gfLeftSideBar.find('#md-settings').find('.simple-tabs').data('gftabs') != undefined) {
        $gfLeftSideBar.find('#md-settings').find('.simple-tabs').trigger('screen-mode-change');
      }

      // init outline
      if ($gryffEditor) {
        $gryffBody.find('.gf_row, .module-wrap, .element-wrap').each(function () {
          jQuery(this).trigger('screen-mode-change');
        });
      }

      if (curentSize != size) {
        _this.changeReponsiveSetting(size);
        $element.find(`.select-screen a[data-size="${size}"]`).trigger('click');

        // Add to gfCount
        const extraCount = {
          value: size,
        };
        if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
          $gryffEditor.data('gfcount').add('resize-screen', extraCount);
        }
      }

      // Scrool đến vị trí ban đầu sau khi đã swich màn hình
      if ($mdSettings.hasClass('active')) {
        var merId = $mdSettings.data('edittingID');
        var $merActive = $gryffBody.find('#' + merId);
        if ($merActive.length > 0) {
          var scrollTop = $($merActive).offset().top;
          if (percentScreen) {
            var top = scrollTop - (window.innerHeight - 50) * percentScreen;
          } else {
            var top = scrollTop - (window.innerHeight - 50) / 3;
          }
          $gfFrame.contents().find('html').scrollTop(top);
        }
      } else {
        if ($firstBlockViewPort) {
          var top = $($firstBlockViewPort).offset().top;
          $gfFrame.contents().find('html').scrollTop(top);
        }
      }

      // fix trường hợp ATOM bị lỗi khi màn hình bị
      if ($gfFrameLoader && !$gfFrameLoader.hasClass('show')) {
        // Trigger 3rd party elements
        $gryffEditor.find('.module-wrap[data-compile="false"]').each(function (i, el) {
          const $el = jQuery(el);
          if ($el.data('gfmodule')) {
            $el.data('gfmodule').refresh();
          }
        });
      }

      HELPER.refreshFrame();

      return false;
    };

    this.changeReponsiveSetting = function (size) {
      // Change responsive
      const $columns = $gfLeftSideBar.find('.columns,.columns-advanced');
      let dataResponsive = 'Desktop';
      switch (size) {
        case 'xs':
          dataResponsive = 'Mobile';
          break;
        case 'sm':
          dataResponsive = 'Tablet';
          break;
        case 'md':
          dataResponsive = 'Laptop';
          break;
        case 'lg':
          dataResponsive = 'Desktop';
          break;
      }
      for (let h = 0; h < $columns.length; h++) {
        const $column = jQuery($columns[h]);

        // Change icon responsive;
        if ($column.attr('data-responsive') == 'true') {
          $column.attr('resposive', dataResponsive);
          const iconButtonReponsive = utils.chooseResponsiveIcon(dataResponsive);
          const $buttonReponsiveBar = $column.find('.gfSGTitleBarResposive');
          $buttonReponsiveBar.html(iconButtonReponsive);

          $column.find('.gfSGResponsiveTools button').removeClass('active');
          $column.find('.gfSGResponsiveTools button[data-caption="' + dataResponsive + '"]').addClass('active');
        }

        HELPER.checkFieldsHideAll($column);

        // Change value in column hide;
        const $formElement = $column.find('input,textarea,select');
        for (let j = 0; j < $formElement.length; j++) {
          const $form = jQuery($formElement[j]);
          const isEvent = false;
          HELPER.checkRequires($column, $form, isEvent);
        }

        // SUPPORT GLOBAL STYLE
        const gsKey = $gfLeftSideBar.find('#md-settings').find('.md-title .mer-title').attr('data-key');
        renderTabSettings.visibleSettingGlobalStyle(gsKey);
      }
    };

    this.init();
  };
  jQuery.fn.gfResTool = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfrestool')) {
        const plugin = new jQuery.gfResTool(this, options);
        jQuery(this).data('gfrestool', plugin);
      }
    });
  };
})(jQuery);
